import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader, Tab, TabList, TabPanel, Tabs } from '@/components/primitives';
import Lookalikes from '@/pages/brand/Lookalikes';
import EmailProtection from '@/pages/brand/EmailProtection';
import People from '@/pages/brand/People';
import '@/styles/brand.css';

/*
 * Brand protection: three ways an attacker can borrow your name, one page. Lookalike domains and email
 * spoofing are found from public DNS and certificate data; people are the executives you ask us to watch.
 * No social network is scraped and no suspicious site is ever opened.
 */
const TABS = ['domains', 'email', 'people'];

export default function Brand() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.includes(params.get('tab')) ? params.get('tab') : 'domains';
  const setTab = (t) => setParams((p) => {
    const next = new URLSearchParams();   // each tab has its own filters, so switching starts clean
    if (t !== 'domains') next.set('tab', t);
    return next;
  }, { replace: true });
  return (
    <div className="pg br" data-testid="brand-page">
      <PageHeader title="Brand protection" subtitle="Stop attackers borrowing your name: imitation domains, spoofed email, and the people they target." />
      <Tabs value={tab} onValueChange={setTab}>
        <TabList label="Brand protection sections">
          <Tab value="domains">Lookalike domains</Tab>
          <Tab value="email">Email protection</Tab>
          <Tab value="people">People</Tab>
        </TabList>
        <TabPanel value="domains"><Lookalikes /></TabPanel>
        <TabPanel value="email"><EmailProtection /></TabPanel>
        <TabPanel value="people"><People /></TabPanel>
      </Tabs>
    </div>
  );
}
